<template>
  <b-modal id="modal-view-plan-work"
    title= "Detail Work Plan"
    centered
    hide-footer
    hide-header
    size="s"
  >
    <div class="view-header p-2 d-flex justify-content-between">
      <div>
        <h5> View Work Plan </h5>
      </div>
      <div>
        <b-button class="button p-0" variant="light" @click="closeModalView">
          <h5><b-icon icon="x"></b-icon></h5>
        </b-button>
      </div>
    </div>
    <div class="mt-3 mb-3">
      <h5 class="py-1 ml-3">{{ workplan.title }}</h5>
      <div class="detail mt-3">
        <div class="content">
          <div class="text-muted">
            <div class="detail-info row justify-content-between d-flex">
              <div class="info col text-muted">
                Target
              </div>
              <div class="info col text-right font-weight-bold">
                {{ workplan.target }}
              </div>
            </div>
            <div class="detail-info row justify-content-between d-flex">
              <div class="info col text-muted">
                Budget
              </div>
              <div class="info col text-right font-weight-bold">
                {{ formattedBudget }}
              </div>
            </div>
            <div class="detail-info row justify-content-between d-flex">
              <div class="info col text-muted">
                Status
              </div>
              <div class="info col text-right font-weight-bold text-white">
                <h5>
                  <b-badge :variant="statusColor">{{ getStatusTextById(workplan.workPlanStatusId) }}</b-badge>
                </h5>
              </div>
            </div>
            <div class="detail-info row justify-content-between d-flex">
              <div class="info col text-muted">
                Due date
              </div>
              <div class="info col text-right font-weight-bold">
                {{ formatFullDate(workplan.endDate) }}
              </div>
            </div>
            <div class="detail-info row justify-content-between d-flex">
              <div class="info col">
                <b-form-textarea
                  id="textarea-no-resize"
                  placeholder="Comment"
                  rows="3"
                  no-resize
                  v-model="workplan.descStatus"
                  readonly
                >{{ workplan.descStatus }}</b-form-textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import api from '@/api'

export default {
  props: {
    workplan: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      planHasStarted: false,
      statusColor: '',
      planDone: false,
      workPlanStatusOptions: []
    }
  },
  computed: {
    formattedBudget() {
      if (this.workplan.budget === null) {
        return ''
      }
      const formatter = new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR'
      })
      return formatter.format(this.workplan.budget)
    },
    statusPlan() {
      if (!this.planDone) {
        return this.planHasStarted ? 'In Progress' : 'On Going'
      } else {
        return 'Done'
      }
    }
  },
  created() {
    this.getStatusOptions()
  },
  methods: {
    async created() {
      try {
        const { data } = await api.workPlan.getListPlanStatus()
        this.statusData = data.data
        const statusOptions = data.data.map(item => ({
          value: item.id,
          text: item.name
        }))
        this.workPlanStatusOptions = statusOptions
      } catch (error) {
        console.error(error)
      }
    },
    closeModalView() {
      this.$bvModal.hide('modal-view-plan-work')
    },
    getDayName(dayIndex) {
      const days = ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu']
      return days[dayIndex]
    },
    getMonthName(monthIndex) {
      const months = [
        'Januari',
        'Februari',
        'Maret',
        'April',
        'Mei',
        'Juni',
        'Juli',
        'Agustus',
        'September',
        'Oktober',
        'November',
        'Desember'
      ]
      return months[monthIndex]
    },
    formatFullDate(dateTimeString) {
      if (dateTimeString) {
        const dateObj = new Date(dateTimeString)
        const day = this.getDayName(dateObj.getDay())
        const date = dateObj.getDate()
        const month = this.getMonthName(dateObj.getMonth())
        const year = dateObj.getFullYear()
        const formattedTime = dateObj.toLocaleTimeString('id-ID', {
          hour: '2-digit',
          minute: '2-digit'
        })

        return `${day}, ${date} ${month} ${year} ${formattedTime}`
      } else {
        return 'Invalid Date'
      }
    },
    getStatusTextById(workPlanStatusId) {
      let statusText = ''
      let statusColor = ''
      switch (workPlanStatusId) {
        case 'c08cb8d2-768e-5432-45d5-6daa74423001':
          statusText = 'On Going'
          statusColor = 'warning'
          break
        case 'c08cb8d2-768e-5432-45d5-6daa74423002':
          statusText = 'In Progress'
          statusColor = 'success'
          break
        case 'c08cb8d2-768e-5432-45d5-6daa74423003':
          statusText = 'Done'
          statusColor = 'success'
          break
        case 'c08cb8d2-768e-5432-45d5-6daa74423004':
          statusText = 'Cancel'
          statusColor = 'danger'
          break
        default:
          statusText = 'Unknown'
          statusColor = 'danger'
          break
      }

      this.statusColor = statusColor
      return statusText
    },
    async getStatusOptions() {
      try {
        const { data } = await api.workPlan.getListPlanStatus()
        this.workPlanStatusOptions = data.data
      } catch (error) {
        console.error(error)
      }
    }
  },
  watch: {
    workplan: {
      handler() {
        this.planHasStarted = this.workplan.firstDate < new Date().toLocaleDateString('en-CA')
        this.planDone = this.workplan.endDate < new Date().toLocaleDateString('en-CA')
        this.statusColor = this.planHasStarted ? 'success' : (this.planDone ? 'secondary' : 'warning')
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
*{
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.view-header{
  border-bottom: 1px solid grey;
}

.button{
  color: white;
  background-color: transparent;
  border: none;
}
.content{
  font-size: 15px;
}

.detail-info{
  padding: 0 17px 0 17px;
  .info{
    padding-top: 7px;
    padding-bottom: 7px;
  }
}

.b-icon.bi{
  color: black;
}

</style>
